import DictionaryItem from "../../../model/dictionary/DictionaryItem";


/**
 * Fetch lead types successful action.
 */
export const LEAD_TYPE_FETCHED = "LEAD_TYPE_FETCHED";
export type LEAD_TYPE_FETCHED = { leadTypes: Array<DictionaryItem> }

/**
 * Create lead type successful action.
 */
export const LEAD_TYPE_CREATED = "LEAD_TYPE_CREATED";
export type LEAD_TYPE_CREATED = { leadType: DictionaryItem }

/**
 * Update lead type successful action.
 */
export const LEAD_TYPE_UPDATED = "LEAD_TYPE_UPDATED";
export type LEAD_TYPE_UPDATED = { leadType: DictionaryItem }

/**
 *  Update lead types sort order successful action.
 */
export const LEAD_TYPE_SORT_ORDER_UPDATED = "LEAD_TYPE_SORT_ORDER_UPDATED";
export type LEAD_TYPE_SORT_ORDER_UPDATED = { leadTypes: Array<DictionaryItem> }
